import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { VnaClientService } from 'app/client/management/service/vna-client.service';

import * as _ from 'underscore';

const SELECT_MULTIPLE_VNA_CLIENT_VALUE_ACCESSOR: any = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectVnaClientMultipleComponent)
};

@Component({
  selector: 'app-select-vna-client-multiple',
  template: `
      <ng-multiselect-dropdown [data]="clients" [(ngModel)]="c" (onSelect)="selected($event)"
        (onSelectAll)="selected($event)" [placeholder]="textDefault" [settings]="settings" >
      </ng-multiselect-dropdown>
      `,
  styleUrls: ['./select-vna-client-multiple.component.scss'],
  providers: [SELECT_MULTIPLE_VNA_CLIENT_VALUE_ACCESSOR]
})
export class SelectVnaClientMultipleComponent implements OnInit, ControlValueAccessor {

  @Input() valueField= 'pk';
  @Input() textField = 'username';
  @Input() textDefault = 'Select clients';

  clients: Array<Object> = [];
  _c: any;

  settings: Object;

  constructor(private clientHandler:VnaClientService) {
    this.settings = {
      singleSelection: false,
      idField: this.valueField,
      textField: this.textField,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true
    }
  }

  ngOnInit() {
    this.clientHandler.getClientList()
          .subscribe(result=>{
              this.clients=result;
              })
  }

  selected(value: any) {
    this.propagateChange(this._c);
  }


  get c(): any { return this._c; };

  set c(v: any) {
    this._c = v;
    this.propagateChange(this._c);
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(value: any): void {
    this._c = value;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/select-vna-client-multiple/select-vna-client-multiple.component.ts